import * as React from 'react';
import { useGetSocialProfilesQuery, useGetWorkspaceSourcesQuery } from '../../../models/graphql';
import { FindContentController, FindContentControllerProps } from './FindContent.controller';
import { gql } from '@apollo/client';
import { useContext, useMemo } from 'react';
import { AppContext } from '../../../providers/AppProvider';

gql`
  query GetWorkspaceSources($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      importFolders {
        ...CoreImportFolderFields
      }
      importSources {
        ...ImportSourceFields
      }
      socialProfiles {
        ...SocialProfileFields
      }
    }
  }

  query SearchThirdPartyProfiles($socialProfileId: ID!, $method: ThirdPartyProfileSearchType!, $term: String!) {
    searchThirdPartyProfiles(socialProfileId: $socialProfileId, method: $method, term: $term) {
      displayName
      username
      photoUrl
      externalId
      platform
      profileUrl
    }
  }

  mutation CreateImportSource($workspaceId: ID!, $input: CreateImportSourceInput!) {
    createImportSource(workspaceId: $workspaceId, input: $input) {
      ...ImportSourceFields
    }
  }
`;

export const FindContentApollo = (): JSX.Element => {
  const { selectedWorkspaceId } = useContext(AppContext);

  const { refetch, data } = useGetWorkspaceSourcesQuery({ variables: { workspaceId: selectedWorkspaceId ?? '' } });
  const profilesResults = useGetSocialProfilesQuery({
    variables: { workspaceId: String(selectedWorkspaceId) }
  });

  const folders = useMemo(
    () => (data ? [...data.workspace.importFolders].sort((a, b) => a.order - b.order) : []),
    [data]
  );

  const sources = useMemo(
    () => (data ? [...data.workspace.importSources].sort((a, b) => a.order - b.order) : []),
    [data]
  );

  const controllerProps: FindContentControllerProps = {
    sources,
    folders,
    socialProfiles: profilesResults.data?.workspace.socialProfiles || [],
    reFetch: refetch
  };

  return <FindContentController {...controllerProps} />;
};
